import React, { useState, useEffect, useContext } from "react"

import { HeaderContext } from "../../../contexts/HeaderProvider"
import {
  MobileNavWrapper,
  MobileNav,
  MobileNavItem,
  MobileWrapper,
  Table,
} from "../styles/Table.styled"

import HeaderPackage from "./Header/Package"
import PackageTableSection from "./PackageTableSection"

const MobileTable = ({ component, isTableNavSticky }) => {
  const [activeItem, setActiveItem] = useState(0)
  const [headerPackages, setheaderPackages] = useState([])
  const [tableData, setTableData] = useState({})
  const { isMobileNavHidden } = useContext(HeaderContext)

  const { packageTableHeaderPackages, packageTableSections } = component

  const getTableData = () => {
    const activeData = []

    packageTableSections?.map((section) => {
      const activeDataRows = []
      section?.sectionRows?.map((row) => {
        return activeDataRows.push({
          id: row?.id,
          rowTitle: row?.rowTitle,
          rowCells: [row?.rowCells[activeItem]],
        })
      })
      return activeData.push({
        id: section?.id,
        sectionTitle: section?.sectionTitle,
        sectionRows: activeDataRows,
      })
    })
    setTableData(activeData)
  }

  useEffect(() => {
    setheaderPackages(packageTableHeaderPackages)
    getTableData()
  }, [])

  useEffect(() => {
    getTableData()
  }, [activeItem])

  return (
    <MobileWrapper>
      <MobileNavWrapper
        isTableNavSticky={isTableNavSticky}
        isMobileNavHidden={isMobileNavHidden}
      >
        {headerPackages.length > 0 && (
          <MobileNav isTableNavSticky={isTableNavSticky}>
            {headerPackages.map((headerPackage, index) => {
              return (
                <MobileNavItem
                  key={index}
                  className={
                    index === activeItem ? "nav-item-active" : "nav-item"
                  }
                  onClick={() => setActiveItem(index)}
                >
                  <HeaderPackage
                    title={headerPackage?.title}
                    stars={headerPackage?.stars}
                    color={headerPackage?.color}
                  />
                </MobileNavItem>
              )
            })}
          </MobileNav>
        )}
      </MobileNavWrapper>
      <Table>
        {tableData.length > 0 &&
          tableData?.map((section) => (
            <PackageTableSection
              key={section?.id}
              sectionTitle={section?.sectionTitle}
              sectionRows={section?.sectionRows}
            />
          ))}
      </Table>
    </MobileWrapper>
  )
}

export default MobileTable
